export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5605.7aee3893.jpg";